import React from 'react'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { grey } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'

import ToolReportsMenu from 'components/Sidebar/Menu/ReportingTools'
import { renderIfAllowed } from 'lib/authorization/AuthorizeComponent'
import bluehavenDomain from 'lib/utility/BluehavenDomain'
import ListItemText from 'components/Sidebar/Styled/ListItemText'
import SubMenu from 'components/Sidebar/Menu/SubMenu'
import { customStyles } from 'components/Sidebar/Styled/CustomStyles'

interface ReportingProps {
  isDrawerVisible: boolean
  handleDropdownCollapse: () => void
}

const Reporting = ({
  isDrawerVisible,
  handleDropdownCollapse,
}: ReportingProps) => {
  const { t } = useTranslation()

  return (
    <SubMenu
      keyItem="report"
      name="reporting"
      dataTestId="reporting"
      isDrawerVisible={isDrawerVisible}
      handleDropdownCollapse={handleDropdownCollapse}
    >
      <List component="div" sx={{ backgroundColor: grey[100] }} disablePadding>
        <ListItemButton
          data-testid="project-reports"
          component={'a'}
          href={`${bluehavenDomain()}/admin/reporting/summary`}
          key="project-reports"
          sx={customStyles.listItemButton}
        >
          <ListItemText primary={t('sidebar.projectReports')} />
        </ListItemButton>
        <ToolReportsMenu
          handleDropdownCollapse={handleDropdownCollapse}
          isDrawerVisible={isDrawerVisible}
        />
        <ListItemButton
          component={'a'}
          data-testid="text-analysis"
          href={`${bluehavenDomain()}/admin/reporting/text_analysis`}
          key="text-analysis"
          sx={customStyles.listItemButton}
        >
          <ListItemText primary={t('sidebar.textAnalysis')} />
        </ListItemButton>
        {renderIfAllowed(
          'text_analysis_v2',
          <ListItemButton
            component={'a'}
            href={`${bluehavenDomain()}/admin/reporting/text_analysis_new`}
            key="text-analysis-new"
            data-testid="text-analysis-new"
            sx={customStyles.listItemButton}
          >
            <ListItemText primary={t('sidebar.textAnalysisNew')} />
          </ListItemButton>,
        )}

        <ListItemButton
          component={'a'}
          href={`${bluehavenDomain()}/admin/reporting/survey_analysis`}
          key="survey-analysis"
          data-testid="survey-analysis"
          sx={customStyles.listItemButton}
        >
          <ListItemText primary={t('sidebar.surveyAnalysis')} />
        </ListItemButton>

        {renderIfAllowed(
          'show_custom_dashboard',
          <ListItemButton
            component={'a'}
            href={`${bluehavenDomain()}/admin/reporting/custom_reports`}
            key="custom-reports"
            data-testid="custom-reports"
            sx={customStyles.listItemButton}
          >
            <ListItemText primary={t('sidebar.customReports')} />
          </ListItemButton>,
        )}

        {renderIfAllowed(
          'submission_manager',
          <ListItemButton
            component={'a'}
            href={`${bluehavenDomain()}/admin/reporting/submissions_manager`}
            key="submissions-manager"
            data-testid="submissions-manager"
            sx={customStyles.listItemButton}
          >
            <ListItemText primary={t('sidebar.submissionManager')} />
          </ListItemButton>,
        )}
      </List>
    </SubMenu>
  )
}

export default Reporting
